import { Outlet, Link } from "react-router-dom";
import React, { useState, useEffect, createContext } from "react";
import "../../css/admin.css";

// import SocketContext from "../../pages/socket-context";
import UsersMsgs from "../../pages/socket-users-msg";

// const Layout = () => {
const Layout = ({socket}) => {

    // const lastSegment = window.location.pathname.split("/").pop();
    const lastSegment = window.location.pathname.split("/");

    const [roomUsers, setRoomUsers] = useState([]);
    const [messagesRecieved, setMessagesReceived] = useState([]);
    // const [roomUsers, setRoomUsers] = useState([]);
    // const [messagesRecieved, setMessagesReceived] = useState([]);
    
    // useEffect(() => {
    //   socket.on('chatroom_users', (data) => {
    //     console.log('chatroom_users are---', data);
    //     setRoomUsers(data);
    //   });
  
    //   return () => socket.off('chatroom_users');
    // }, [socket]);

    // useEffect(() => {
    //     socket.on('receive_message', (data) => {
    //       console.log("receive_message-->>", data);
    //       setMessagesReceived((state) => [
    //         ...state,
    //         {
    //           message: data.message,
    //           username: data.username,
    //           __createdtime__: data.__createdtime__,
    //         },
    //       ]);
    //     });
    
    //     // Remove event listener on component unmount
    //     return () => socket.off('receive_message');
    // }, [socket]);

    // const lastSegment = window.location.pathname.split("/").pop();
    // const lastSegment = window.location.pathname.split("/");
    const [openMenu, setOpenMenu] = useState(true);

    const toggleMenu = () => {
        setOpenMenu(!openMenu);
    };

    // const [user, setUser] = useState([]);
    // const [showContent, setShowContent] = useState(false);

    // useEffect(() => {
    //     const userData = JSON.parse(localStorage.getItem("user-data"));
    //     setUser(userData[0].firstName);
    //     setShowContent(true);
    // }, []);

    return (
        <>
            <nav className="sb-topnav navbar navbar-expand navbar-dark bg-dark justify-content-between">
                <div className="d-flex align-items-start">
                    <Link className="navbar-brand ps-3" to="/servant">TMS</Link>
                    <button className="btn btn-link btn-sm order-1 order-lg-0 me-4 me-lg-0 mt-1" id="sidebarToggle" onClick={toggleMenu} href="#!">
                        <i className="fas fa-bars"></i>
                    </button>
                </div>
                <ul className="navbar-nav ms-auto ms-md-0 me-3 me-lg-4">
                    <li className="nav-item dropdown">
                        <a className="nav-link dropdown-toggle" id="navbarDropdown" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false"><i className="fas fa-user fa-fw"></i></a>
                        <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                            <li><Link className="dropdown-item" to={lastSegment[1] === 'mentor' ? "/mentor/settings" : '/civil-servant/settings'}>Settings</Link></li>
                            <li><Link to="/logout" className="dropdown-item">Logout</Link></li>
                        </ul>
                    </li>
                </ul>
            </nav>

            <div id="layoutSidenav">
                {openMenu ? (
                <div id="layoutSidenav_nav">
                    <nav className="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
                        <div className="sb-sidenav-menu">
                            <div className="nav">
                                <div className="sb-sidenav-menu-heading">Core</div>
                                <Link className="nav-link" to=".">
                                    <div className="sb-nav-link-icon"><i className="fas fa-tachometer-alt"></i></div>
                                    Dashboard
                                </Link>
                                <div className="sb-sidenav-menu-heading">Interface</div>
                                {/* check left sidebar mentors */}
                                {

                                    lastSegment[1].includes('mentor') ? 
                                    <>
                                        {/* <a className="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#collapseLayouts" aria-expanded="false" aria-controls="collapseLayouts">
                                            <div className="sb-nav-link-icon"><i className="fas fa-message"></i></div>
                                            Messages
                                            <div className="sb-sidenav-collapse-arrow"><i className="fas fa-angle-down"></i></div>
                                        </a>
                                        <div className="collapse" id="collapseLayouts" aria-labelledby="headingOne" data-bs-parent="#sidenavAccordion">
                                            <nav className="sb-sidenav-menu-nested nav">
                                                <Link to="/mentor/message" className="nav-link">Message</Link>
                                            </nav>
                                        </div> */}
                                    </>    
                                    :
                                    <>
                                        <Link className="nav-link" to="./lessons">
                                            <div className="sb-nav-link-icon"><i className="fas fa-person-chalkboard"></i></div>
                                            Lessons
                                        </Link>
                                        <Link className="nav-link" to="./training">
                                            <div className="sb-nav-link-icon"><i className="fas fa-chalkboard-teacher"></i></div>
                                            Post Training
                                        </Link>

                                        {/* <a className="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#collapseLayouts" aria-expanded="false" aria-controls="collapseLayouts">
                                            <div className="sb-nav-link-icon"><i className="fas fa-message"></i></div>
                                            Messages
                                            <div className="sb-sidenav-collapse-arrow"><i className="fas fa-angle-down"></i></div>
                                        </a>
                                        <div className="collapse" id="collapseLayouts" aria-labelledby="headingOne" data-bs-parent="#sidenavAccordion">
                                            <nav className="sb-sidenav-menu-nested nav">
                                                <Link to="./messages" className="nav-link">All Messages</Link>
                                                <Link to="./messages/join-room" className="nav-link">Online Chat</Link>
                                            </nav>
                                        </div> */}
                                    </>
                                }

                                <a className="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#collapseLayouts" aria-expanded="false" aria-controls="collapseLayouts">
                                    <div className="sb-nav-link-icon"><i className="fas fa-message"></i></div>
                                    Messages
                                    <div className="sb-sidenav-collapse-arrow"><i className="fas fa-angle-down"></i></div>
                                </a>
                                <div className="collapse" id="collapseLayouts" aria-labelledby="headingOne" data-bs-parent="#sidenavAccordion">
                                    <nav className="sb-sidenav-menu-nested nav">
                                        <Link to="./messages" className="nav-link">All Messages</Link>
                                        <Link to="./messages/join-room" className="nav-link">Online Chat</Link>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </nav>
                </div>
                ) : null}
                <div id="layoutSidenav_content">
                    <UsersMsgs socket={socket} />

                    {/* <Outlet /> */}
                    {/* <SocketContext.Provider value={{roomUsers:roomUsers, messagesRecieved:messagesRecieved}}> */}
                    
                    {/* <SocketContext.Provider value={{roomUsers:roomUsers, messagesRecieved:messagesRecieved, setMessagesReceived:setMessagesReceived}}>
                        <Outlet />
                    </SocketContext.Provider> */}

                    <footer className="py-4 bg-light mt-auto">
                        <div className="container-fluid px-4">
                            <div className="d-flex align-items-center justify-content-between small">
                                <div className="text-muted">Copyright &copy; tms 2022</div>
                                <div>
                                    <a href="#">Privacy Policy</a>
                                    &middot;
                                    <a href="#">Terms &amp; Conditions</a>
                                </div>
                            </div>
                        </div>
                    </footer>
                </div>
            </div>
        </>
    )
};

export default Layout;